export default __webpack_public_path__ + "static/media/wishlist.38875c74.svg";